import { Check, ChevronDown, MapPinIcon } from "lucide-react";
// @ts-ignore
import profileImage from "../../assets/images/profilepic.png";
import ContactIcon from "../../assets/svg/ContactIcon";
import EducationIcon from "../../assets/svg/EducationIcon";
import ExperienceIcon from "../../assets/svg/ExperienceIcon";
import AboutIcon from "../../assets/svg/AboutIcon";
import SkillsIconn from "../../assets/svg/SkillsIconn";
import { useState } from "react";

const tabs = [
  {
    label: "About",
    icon: <AboutIcon />,
  },
  {
    label: "Work Experience",
    icon: <ExperienceIcon />,
  },
  {
    label: "Skills",
    icon: <SkillsIconn />,
  },
  {
    label: "Education & Certifications",
    icon: <EducationIcon />,
  },
  {
    label: "Contact Details",
    icon: <ContactIcon />,
  },
];

const ProfilePage2 = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="flex flex-1 gap-3">
      <div className="flex flex-col flex-1 p-5 bg-white rounded-md">
        {/* Profile info */}
        <div className="flex items-center gap-4">
          <div className="h-36 w-3h-36 rounded-full border flex items-center justify-center bg-slate-50">
            {true ? (
              <img src={profileImage} className="h-full w-full" />
            ) : (
              <span className="font-bold text-4xl">MC</span>
            )}
          </div>
          <div className="flex flex-col justify-center">
            <span className="bg-green-50 text-green-700 w-max rounded-full font-semibold text-xss px-2 mb-1">
              Basic profile generated
            </span>
            <span className="font-semibold text-2xl">Alex Morgan</span>
            <span className="text-xss font-medium text-light-black mt-1">
              Data Analyst
            </span>
            <div className="flex items-center gap-1 mt-1">
              <MapPinIcon size={12} color="gray" />
              <span className="text-xss font-medium text-light-black">
                London, UK
              </span>
            </div>
            <div className="flex items-center mt-4 gap-3">
              <div className="bg-blue-50 text-blue-600 rounded-full text-xss font-semibold px-2 py-1">
                Technology/Software
              </div>
              <div className="bg-gray-50 text-gray-600 rounded-full text-xss font-semibold px-2 py-1">
                Step 1 + 2 details only
              </div>
            </div>
          </div>
        </div>
        {/* Tabs container */}
        <div className="flex items-center justify-between w-full rounded-full border p-1.5 mt-5">
          {tabs?.map((tab, tabIndex) => {
            const isActive = tabIndex === activeTab;
            return (
              <button
                onClick={() => setActiveTab(tabIndex)}
                className={`flex items-center justify-center rounded-full py-1 px-5 ${isActive ? "bg-slate-700 text-white" : "text-light-black"}`}
              >
                <span className="font-semibold text-xss">{tab?.label}</span>
              </button>
            );
          })}
        </div>
        {/* Render Body  */}
        <div className="flex gap-3 bg-gray-100 rounded-md mt-5 p-4 min-h-96 w-full">
          <div className="flex flex-col gap-2 w-[70%]">
            <span className="font-semibold text-xs">Profile summary</span>
            <p className="text-xss leading-5 font-medium bg-white p-3 rounded-md text-light-black">
              Strategic technology leader with over 10 years of experience in
              building scalable distributed systems and high-performance
              engineering teams. Expert in cloud architecture, microservices,
              and modern frontend frameworks. Proven track record of delivering
              complex enterprise solutions that drive business growth and
              operational efficiency.
            </p>
          </div>
          <div className="flex flex-col gap-3 mt-6 w-[30%] shrink-0">
            <div className="bg-white rounded-md p-3 flex flex-col gap-2 min-h-20">
              <span className="font-semibold text-charcoal text-xs">
                Work Experience
              </span>
              <span className="text-xss text-charcoal font-medium">
                Strategic technology leader with over 10 years{" "}
              </span>
            </div>
            <div className="bg-white rounded-md p-3 flex flex-col gap-2 min-h-20">
              <span className="font-semibold text-charcoal text-xs">Skills</span>
              <span className="text-xss text-charcoal font-medium">
                React, Node Js
              </span>
            </div>
            <div className="bg-white rounded-md p-3 flex flex-col gap-2 min-h-20">
              <span className="font-semibold text-charcoal text-xs">
                Education & Certifications
              </span>
              <span className="text-xss text-charcoal font-medium">
                Masters Degree in Software Engineering
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Profile setup tracker */}
      <div className="w-[25%] bg-white rounded-md p-4">
        <div className="flex items-center">
          <div className="flex flex-col">
            <span className="font-semibold">Recommended next steps</span>
            <span className="font-medium text-xss text-light-black">
              Continue building your candidate profile
            </span>
          </div>
          <span className="bg-green-50 text-green-700 rounded-full font-semibold text-xss px-1.5">
            90%
          </span>
        </div>

        <div className="flex flex-col gap-3 mt-5">
          {/* About */}
          <div className="flex border rounded-md bg-green-50 p-3 gap-3">
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-green-200">
              <Check size={10} />
            </div>
            <div className="flex flex-col flex-1">
              <span className="text-xs font-semibold">About</span>
              <span className="text-xss font-medium text-light-black">
                View About
              </span>
            </div>
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
              <ChevronDown size={20} />
            </div>
          </div>
          {/* Experience */}
          <div className="flex flex-col border rounded-md bg-white p-3 gap-3">
            <div className="flex gap-3">
              <div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">
                2
              </div>
              <div className="flex flex-col flex-1">
                <span className="text-xs font-semibold">Experience</span>
                <span className="text-xss font-medium text-light-black">
                  Add your work history, achievements and responsibilities.
                </span>
              </div>
              <div className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
                <ChevronDown size={20} />
              </div>
            </div>
            <span className="text-xss font-medium text-light-black">
              Add your work history, achievements and responsibilities.
            </span>
            <button className="font-semibold text-light-black rounded-full border bg-gray-50 text-xss py-2">
              Complete Experience
            </button>
          </div>
          {/* Skills */}
          <div className="flex border rounded-md bg-white p-3 gap-3">
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-50 text-xs font-semibold text-blue-700">
              3
            </div>
            <div className="flex flex-col flex-1">
              <span className="text-xs font-semibold">Skils</span>
              <span className="text-xss font-medium text-light-black">
                Complete skills
              </span>
            </div>
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
              <ChevronDown size={20} />
            </div>
          </div>
          {/* Education */}
          <div className="flex border rounded-md bg-white p-3 gap-3">
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-50 text-xs font-semibold text-blue-700">
              4
            </div>
            <div className="flex flex-col flex-1">
              <span className="text-xs font-semibold">
                Education & Certifications
              </span>
              <span className="text-xss font-medium text-light-black">
                Fill up certifications
              </span>
            </div>
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
              <ChevronDown size={20} />
            </div>
          </div>
          {/* Contact */}
          <div className="flex border rounded-md bg-white p-3 gap-3">
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-50 text-xs font-semibold text-blue-700">
              5
            </div>
            <div className="flex flex-col flex-1">
              <span className="text-xs font-semibold">Contact Details</span>
              <span className="text-xss font-medium text-light-black">
                Fill up contact details
              </span>
            </div>
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
              <ChevronDown size={20} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage2;
